import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Button, Container, Form, FormGroup, Input, Label, Row, Col } from 'reactstrap';
import * as moment from 'moment';
import Breadcrumb from '../components/AdminBreadcrumb';

import * as actions from '../actions/Session';

class Session extends React.Component {

    handleChange = (e) => this.props.actions.updateSession(e.target.name, e.target.value);

    getYearOptions = () => {
        let options = [];
        const year = moment().year();

        var i;
        for (i = year - 10; i < year + 10; i++) {
            options.push(<option key={i} value={i}>{i}</option>);
        }

        return options;
    }

    getSessions = () =>
        this.props.sessions.map(x => <option key={x.get('sessionId')} value={x.get('sessionId')}>{`${x.get('year')} - ${x.get('name')}`}</option>)
            .splice(0, 0, <option key={''} value={undefined}>Do Not Copy</option>);

    handleSave = () => {
        const { name } = this.props.session.toJS();
        if (name) {
            this.props.actions.saveSession(this.props.session);
            this.props.history.push('/sessions');
        }
    }

    render() {
        const { sessionId, name, year } = this.props.session.toJS();

        return (
            <Container>
                <div style={{ paddingBottom: '10px' }}>
                    <Breadcrumb history={this.props.history} />
                </div>
                <Form>
                    <Row>
                        <Col>
                            <FormGroup>
                                <Label>Session Name:</Label>
                                <Input
                                    type='text'
                                    required value={name || ''}
                                    onChange={this.handleChange}
                                    name='name'
                                    invalid={!name}
                                />
                            </FormGroup>
                        </Col>
                        <Col>
                            <FormGroup>
                                <Label>Session Year:</Label>
                                <Input
                                    type='select'
                                    onChange={this.handleChange}
                                    value={year}
                                    name='year'
                                >
                                    {this.getYearOptions()}
                                </Input>
                            </FormGroup>
                        </Col>
                    </Row>
                    {
                        !sessionId &&
                        <Row>
                            <Col>
                                <Label>Copy Curriculum From:</Label>
                                <Input
                                    type='select'
                                    onChange={this.handleChange}
                                    name='copyFromSessionId' >{this.getSessions()}
                                </Input>
                            </Col>
                        </Row>
                    }
                    <Row>
                        <Col>
                            <hr />
                            <Button type="submit" className={'float-right'} disabled={!name} onClick={this.handleSave}>Save</Button>
                        </Col>
                    </Row>
                </Form >
            </Container>
        );
    }
}

function mapStateToProps(state, ownProps) {
    return {
        session: state.Session,
        sessions: state.Sessions
    }
}

function mapDispatchToProps(dispatch) {
    return { actions: bindActionCreators({ ...actions }, dispatch) }
}

export default connect(mapStateToProps, mapDispatchToProps)(Session);